import { render, staticRenderFns } from "./goodsEdititRecord.vue?vue&type=template&id=b10e009e&scoped=true&"
import script from "./goodsEdititRecord.vue?vue&type=script&lang=js&"
export * from "./goodsEdititRecord.vue?vue&type=script&lang=js&"
import style0 from "./goodsEdititRecord.vue?vue&type=style&index=0&id=b10e009e&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b10e009e",
  null
  
)

export default component.exports